export default "__VITE_ASSET__ea2c6b18__"